import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, CarFront, Heart, Shield, Users } from "lucide-react";
import { HAPPY_CUSTOMERS } from "@/config";

export const HappyCustomers: React.FC = () => (
  <section className="customer-stories" data-testid="happy-customers" aria-labelledby="customer-stories-title">
    <div className="container-x customer-stories-inner">
      <header className="customer-stories-heading">
        <p className="customer-stories-eyebrow"><span />Happy Customers<span /></p>
        <h2 id="customer-stories-title">Real Handovers. Real <span>Happy Customers.</span></h2>
        <p>There’s nothing more rewarding than seeing our customers drive away with confidence.<br />
          Here are just a few of the amazing people I’ve had the pleasure of helping.</p>
      </header>

      <div className="customer-stories-grid">
        {HAPPY_CUSTOMERS.map((customer, index) => (
          <article className="customer-story" key={customer.image} data-testid={`happy-customer-${index}`}>
            <div className="customer-story-photo">
              <img src={customer.image} alt={customer.caption} loading="lazy" style={{ transform: `translateY(${customer.offsetY}) scale(${customer.scale})`, transformOrigin: "center center" }} />
            </div>
          </article>
        ))}
      </div>

      <div className="customer-stories-cta">
        <span className="customer-cta-icon"><CarFront aria-hidden="true" /></span>
        <div className="customer-cta-copy">
          <p>Ready for yours?</p>
          <h3>Ready to find your next car?</h3>
          <span>Let’s find the right vehicle for you — with the same personal service, honesty, and support.</span>
        </div>
        <div className="customer-cta-trust">
          {[
            { icon: Users, title: "Personal Support", desc: "From start to finish" },
            { icon: Shield, title: "Trusted Advice", desc: "No pressure, just help" },
            { icon: Heart, title: "Happy Customers", desc: "Real people, real stories" },
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title}><span><Icon aria-hidden="true" /></span><div><strong>{title}</strong><small>{desc}</small></div></div>
          ))}
        </div>
        <Link to="/contact/" className="customer-cta-button">Get In Touch <ArrowRight aria-hidden="true" /></Link>
      </div>
    </div>
  </section>
);

export default HappyCustomers;
